module.exports = __webpack_public_path__ + "static/media/thumb_KRJQ8019_1024a.c063254d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/cycle/kama_yunek/thumb_KRJQ8019_1024a.jpg
// module id = 154
// module chunks = 0